import { useEffect, useState } from 'react'

import Api from 'services/api'

import WarrantyInfo from 'types/WarrantyInfo'

const useWarrantyInfo = (
  serialNumber: string,
  retrieveCached: boolean,
  isFeatureDisabled: boolean = false
) => {
  const [warrantyInfo, setWarrantyInfo] = useState<WarrantyInfo | null>(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    if (isFeatureDisabled) {
      return
    }

    setIsLoaded(false)
    setWarrantyInfo(null)

    if (serialNumber?.trim().length === 0) {
      setIsLoaded(true)
    } else {
      Api.WarrantyInfo.get(serialNumber, retrieveCached, false)
        .then((res) => {
          setWarrantyInfo(res)
          setIsLoaded(true)
          setHasError(false)
        })
        .catch(() => {
          setWarrantyInfo(null)
          setIsLoaded(true)
          setHasError(true)
        })
    }
  }, [serialNumber]) // eslint-disable-line react-hooks/exhaustive-deps

  return { warrantyInfo, isLoaded, hasError }
}

export default useWarrantyInfo
